import * as actionTypes from './actionTypes';
import { Purchase } from './types';

/*------------------------------------------------------------------------------------------------*/
/* Purchases Fetch Actions                                                                        */
/*------------------------------------------------------------------------------------------------*/
/**
 * fetchPurchasesRequest
 * Fetch purchases request action.
 */
export const fetchPurchasesRequest = () => ({
  type: actionTypes.FETCH_PURCHASES_REQUEST,
});

/**
 * fetchPurchasesResponse
 * Fetch purchases response action.
 */
export const fetchPurchasesResponse = (response: Purchase[]) => ({
  type: actionTypes.FETCH_PURCHASES_RESPONSE,
  response,
});
